<template>
  <b-container
    fluid="md"
    class="square-payment-payment-rules-fact-error"
  >
    <b-row>
      <b-col>
        <div class="title pb-4">
          <span class="icon-container">
            <font-awesome-icon
              icon="triangle-exclamation"
              size="2x"
              class="icon"
              fixed-width
              color="red"
            />
          </span>
          <span class="h3 pr-4">
            Payment rules error
          </span>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="error-type">
          Type: {{ fact }}
        </div>
        <div class="error-reason">
          Reason: {{ reason }}
        </div>

        <div class="error-message">
          Message: {{ errMessage }}
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'payment-rules-fact-error',
  props: {
    error: {
      type: [Object, Error],
      required: true
    }
  },
  computed: {
    fact: function() {
      return this.error.data.fact
    },
    reason: function() {
      return this.error.reason
    },
    errMessage: function() {
      return this.error.message
    }
  }
}
</script>

<style>

</style>
